import type { HttpClient } from '@angular/common/http';
import type { Model } from '@thevillages/schemas';

import type { AvailableModelsParamsType } from '../available-models';

import { Environment } from '../../../../environments/environment';
import { AddQueryParams } from '../../../utils/add-query-params';
import { GetRequest } from '../../../utils/get-request';

export async function ModelsLoader(
  http: HttpClient,
  params: AvailableModelsParamsType,
): Promise<Model[]> {
  const _base = `${Environment.apiUrl}/models`;
  const _url = params.id ? `${_base}/${params.id}` : AddQueryParams(_base, params);

  return GetRequest<Model[]>(http, _url, { priority: 'low' });
}
